import RbButton, { ButtonSize } from "../../bosch-react/components/button/RbButton";
import Helper from "../libraries/Helper";

export interface EmailProps {
    recipient: string;
    subject: string;
    body: string;
    buttonTitle?: string
}

export const OpenOutlookLink: React.FC<EmailProps> = ({ recipient, subject, body, buttonTitle }) => {
    const handleClick = () => {
        Helper.openOutlookForSupport(recipient, subject, body);
    };

    return (
        <RbButton
            spanClassName="support-icon pointer"
            label={!!buttonTitle ? buttonTitle : "Support"}
            size={ButtonSize.Small}
            onClick={handleClick}
        ></RbButton>
    );
};